const SECTIONS = [
  { id: "getting-started", label: "Getting Started", sort: 1 },
  { id: "setup", label: "Setting Up Your Business", sort: 2 },
  { id: "training", label: "Training and Versioning", sort: 3 },
  { id: "nutrition", label: "Nutrition", sort: 4 },
  { id: "communication", label: "Communication", sort: 5 },
  { id: "reports", label: "Reports and Progress", sort: 6 },
  { id: "library", label: "Library and Resources", sort: 7 },
  { id: "account", label: "Account", sort: 8 },
];

export default SECTIONS;

export const SECTION_MAP = Object.fromEntries(
  SECTIONS.map((s) => [s.id, s]),
);
